import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import { format } from 'date-fns';
import TransparentButton from '@/trio-ui/TransparentButton';
import UserInitials from '@/trio-ui/UserInitials';
import { User } from '@/types/api';
import { getFirstAndLastNamesSplitted } from '@/utils/format';
import * as Styles from './InterviewNote.styles';
import DialogBox from '../DialogBox';
import TextEditor from '../TextEditor';

export type InterviewNoteComponentProps = {
  isEditing: boolean;
  canSave: boolean;
  note: string;
  author?: User;
  publishedAt?: Date;
  isDeleteModalOpen: boolean;
  isInitialNote: boolean;
  isActionLoading: boolean;
  onChangeNote: (value: string) => void;
  onToggleIsEditing: () => void;
  onSaveNote: () => void;
  onDeleteNote: () => void;
  onCancelEdition: () => void;
  onToggleDeleteModal: (event?: any) => void;
};

export default function InterviewNoteComponent({
  author,
  publishedAt,
  isEditing,
  canSave,
  note,
  isActionLoading,
  isDeleteModalOpen,
  isInitialNote,
  onChangeNote,
  onSaveNote,
  onToggleIsEditing,
  onDeleteNote,
  onToggleDeleteModal,
  onCancelEdition,
}: InterviewNoteComponentProps): JSX.Element {
  const [firstName, lastName] = getFirstAndLastNamesSplitted(author?.name);

  return (
    <>
      <Styles.Box isPublished={!!publishedAt} isInitialNote={isInitialNote}>
        {!!publishedAt && (
          <Styles.NoteInfos>
            <UserInitials size={24} firstName={firstName} lastName={lastName} />
            <Styles.AuthorName>{author?.name}</Styles.AuthorName>
            <Styles.NoteTime>{format(publishedAt, 'MMM d HH:MM  a')}</Styles.NoteTime>
          </Styles.NoteInfos>
        )}

        <TextEditor
          value={note}
          onChangeText={onChangeNote}
          isEditing={isEditing}
          hideButtons
          hideEditButton
        />

        <Styles.ButtonsBox>
          {isEditing ? (
            <>
              <TransparentButton
                isBlueButton
                icon={SaveIcon}
                onClick={onSaveNote}
                disabled={!canSave || isActionLoading}
              >
                Save
              </TransparentButton>

              <TransparentButton
                icon={DeleteIcon}
                isRedButton
                onClick={onCancelEdition}
                disabled={isActionLoading}
              >
                Cancel
              </TransparentButton>
            </>
          ) : (
            <>
              <TransparentButton
                icon={EditIcon}
                onClick={onToggleIsEditing}
                disabled={isActionLoading}
              >
                Edit
              </TransparentButton>

              <TransparentButton
                icon={DeleteIcon}
                isRedButton
                onClick={onToggleDeleteModal}
                disabled={isActionLoading}
              >
                Delete
              </TransparentButton>
            </>
          )}
        </Styles.ButtonsBox>
      </Styles.Box>

      <DialogBox
        isOpen={isDeleteModalOpen}
        onCancelHandler={onToggleDeleteModal}
        onConfirmHandler={onDeleteNote}
      />
    </>
  );
}
